import React from 'react';
import clsx from 'clsx';

export type FormTextProps = React.HTMLAttributes<HTMLDivElement>;

const FormText = ({ id, className, children, ...props }: FormTextProps) => {
	return (
		<div id={id} className={clsx('form-text', className)} {...props}>
			{children}
		</div>
	);
};

export type FormInputTextProps = Partial<FormTextProps> & {
	name: string;
	text: React.ReactNode
}

export const FormInputText = ({ name, className, text, ...props }: FormInputTextProps) => {
	return (
		<FormText
			id={`${name}-text`}
			style={{ marginLeft: '1rem' }}
			className={clsx('fw-bold text-danger', className)}
			{...props}
		>
			{text}
		</FormText>
	)
}

export default FormText;
